import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { HeadingBox, Logo } from "cakemail-ui-components/lib/react";
import { I18n } from "react-redux-i18n";
import { getReferalBadgeLink } from "utils/IsValidEmail";
import { LIMIT_FEATURE, limitsFeaturesAccess } from "utils/LimitsAndFeatures";

const ListSubscription = (props) => {
	let title = I18n.t("app-lists-initial-redirection-subscription-title");
	let text = I18n.t("app-lists-initial-redirection-subscription-desc");

	if (props.type === "doptin") {
		title = I18n.t("app-lists-initial-redirection-subscription-doptin-title");
		text = I18n.t("app-lists-initial-redirection-subscription-doptin-desc");
	} else if (props.listName) {
		text = I18n.t("app-lists-initial-redirection-subscription-desc-name");
	}

	let utmId = "";
	let utmType = "list";

	if (props.formId) {
		utmType = "form";
		utmId = props.formId;
	}
	if (props.listId) {
		utmId += props.formId ? "_list_" + props.listId : props.listId;
	}

	let logoLink = getReferalBadgeLink(utmId, utmType, "subscribe");
	const removeLogo = limitsFeaturesAccess(
		LIMIT_FEATURE.INSERT_RESELLER_LOGO,
		props.publicUserBrand?.config?.usage_limits
	);

	return (
		<div className="optIn">
			{props.goodImg && (
				<img
					className="accountLogo"
					src={props.imgUrl}
					{...props.imgExtraAttr}
				/>
			)}
			<HeadingBox title={title} text={text} />

			{props.type === "optin" && props.listName && (
				<div className="listNameContainer">
					<p>{props.listName}</p>
				</div>
			)}

			{!removeLogo && (
				<a href={logoLink}>
					<Logo url={props.logo} alt={props.resellerName} />
				</a>
			)}
		</div>
	);
};

ListSubscription.propTypes = {
	logo: PropTypes.string,
	resellerName: PropTypes.string,
	history: PropTypes.object,
	goodImg: PropTypes.bool,
	imgUrl: PropTypes.string,
	imgExtraAttr: PropTypes.object,
	listName: PropTypes.string,
	type: PropTypes.string,
	addUtm: PropTypes.func,
	formId: PropTypes.string,
	listId: PropTypes.string,
	publicUserBrand: PropTypes.object,
};

export default withRouter(ListSubscription);
